import type { FaireProductEntity } from "../../entity_types/product";

export const p_b8w1uwvddo: FaireProductEntity = {
  token: "p_b8w1uwvddo",
  type: "product",
  name: "Tan Checker Chewy Vuiton Bones | Plush Squeaker Dog Toy",
  brandToken: "b_6uxa229g",
  brandName: "Haute Diggity Dog",
  imageUrl: "https://cdn.faire.com/res/hszgttpjt/image/upload/870a7a8c01f0b60665ed063f62262987c510c5336bd22395fed90f8dd76cdd53/1564780697.jpg",
  galleryImageUrls: [
    "https://cdn.faire.com/res/hszgttpjt/image/upload/0b99dd50321b9c735b9289b4d7f5205af7235f07f4a11baa9aed8d21d1eae55c/1564780758.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/cae40620e0efc40e738473d0a0eaf4ee7d582534eba86b43d57b3d818feebb72/1564780767.jpg",
    "https://cdn.faire.com/res/hszgttpjt/image/upload/516e2d36af9f43f74cf4393974772139fa1136d7f2d3e1aa6ec856f0e842402f/1564780801.jpg"
  ],
  priceDollars: 12.48,
  description: "Tan Checker Chewy Vuiton Bone Toys\n\nDoes your haute-couture hound need a toy that’s as stylish as they are? Then look no further than the Chewy Vuiton Checker Bone Toy! It features the iconic checkered pattern that every furry fashionista drools over. The soft plush exterior provides the perfect surface to really sink their teeth into. And when they do, they’ll discover the delightful hidden squeaker inside! \n\nTan Checker Chewy Vuiton Bone now available in 3 sizes\n\nSmall measures 4.5” x 3” x 1”\n\nLarge measures 6” x 4” x 1”\n\nXL measures 9” x 6” x 1.5”s\n\nXL Checker Bone features a durable mesh lining \nfor fabulously-ferocious chewers.\n\nThis product is individually packaged in a polybag. All Haute Diggity Dog Products include a hangtag that displays the HDD logo and UPC barcode.\n\nImported",
  tags: [],
  msrpDollars: 24.95,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-12T18:46:37.010Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
